<template>
	<el-dialog title="添加" v-model="isAdd" width="40%" center :close-on-click-modal="false" @closed="dialogClosedHandle">
		<div class="page_warp scroll-view" @click="closeTree">
			<div class="input_img_row">
				<div class="input_lable">用户头像：</div>
				<div class="input_box">
					<el-upload action="none" v-bind:show-file-list="false" v-bind:auto-upload="false"
						v-bind:multiple="false" v-bind:on-change="handleAddUploadChange" accept=".jpg,.jpeg,.png">
						<div class="blank-img" style="border-radius: 50%">
							<!-- <img style="border-radius: 50%" width="72" height="72"
								src="@/assets/images/icon-user-bg.png" alt="" v-if="!dataItem.userHeadImg" />
							<img :src="dataItem.userHeadImg" alt="" width="72" height="72" style="border-radius: 50%"
								v-else /> -->
							<div class="blank-img" v-if="dataItem.userHeadImg == ''" style="border-radius: 50%">
								<img style="border-radius: 50%" width="72" height="72"
									src="@/assets/images/icon-user-bg.png" alt="" />
							</div>
							<img v-bind:src="dataItem.userHeadImg" alt="" width="72" height="72"
								style="border-radius: 50%" v-else />
						</div>
					</el-upload>
				</div>
			</div>

			<div class="input_row">
				<div class="input_lable">登录账号：</div>
				<div class="input_box">
					<el-input type="text" placeholder="请输入" v-model="dataItem.userLgname" />
				</div>
			</div>

			<div class="input_row">
				<div class="input_lable">用户姓名：</div>
				<div class="input_box">
					<el-input type="text" placeholder="请输入" v-model="dataItem.userNickname" />
				</div>
			</div>

			<div class="input_row">
				<div class="input_lable">身份证号：</div>
				<div class="input_box">
					<el-input type="text" placeholder="请输入" v-model="dataItem.userCardid" />
				</div>
			</div>

			<div class="input_row">
				<div class="input_lable">手机号码：</div>
				<div class="input_box">
					<el-input type="text" placeholder="请输入" v-model="dataItem.userPhone" />
				</div>
			</div>

			<div class="input_row">
				<div class="input_lable">角色管理：</div>
				<div class="input_box">
					<el-select placeholder="请选择角色" multiple v-model="dataItem.roleList" @change="getEditRole">
						<el-option v-for="item in roleList" :label="item.roleName" :value="item.roleId"
							:key="item.roleId" ></el-option>
					</el-select>
				</div>
			</div>

<!-- 			<div class="input_row">
				<div class="input_lable">用户状态：</div>
				<div class="input_box">
					<el-switch v-model="dataItem.userState" active-text="正常" inactive-text="禁用">
					</el-switch>
				</div>
			</div>

			<div class="input_row">
				<div class="input_lable">所属部门：</div>
				<div class="input_box selectTree" @click.stop="showTree">
					<el-input v-model="valueTitle" class="cursor" readonly placeholder="请选择部门">
						<template #suffix>
							<i class="iconfont icon-xia" :class="isShowTree?'transform180':''"></i>
						</template>
					</el-input>
					<div class="tree_warp" v-if="isShowTree">
						<el-tree :data="treeData" :props="defaultProps" @node-click="handleNodeClick"
							:highlight-current="true" node-key="id" default-expand-all :expand-on-click-node="false"
							ref="tree" :accordion="true"></el-tree>
					</div>

				</div>
			</div> -->

			<div class="footer_btn_warp">
				<div class="cancle_btn" @click="closeModal()">取消</div>
				<div class="confirm_btn" @click="submit()">确定</div>
			</div>
		</div>
	</el-dialog>
</template>

<script>
	import {
		defineComponent,
		reactive,
		toRefs,
		getCurrentInstance,
		onMounted,
		nextTick,
	} from "vue";
	import {
		imgFileToBase64,
		isPhone,
		isIdNo
	} from "@/libs/tools";
	import {
		useStore
	} from "vuex";
	import {
		apiObj
	} from "@/config/api";

	import "@riophae/vue-treeselect/dist/vue-treeselect.css";
	import * as imageConversion from "image-conversion";
	export default defineComponent({
		name: "Add",
		emits: ["getData"],
		setup(props, context) {
			const store = useStore();
			const {
				proxy
			} = getCurrentInstance();

			const getData = () => {
				context.emit("getData");
			};
			onMounted(() => {
				nextTick(() => {});
			});
			const data = reactive({
				isAdd: false,
				treeData: [],
				roleList: [],
				defaultProps: {
					children: "children",
					label: "text",
				},
				valueTitle: "",
				isShowTree: false,
				dataItem: {
					userLgname: "", //角色账号
					userNickname: "", //角色名
					userHeadImg: "", //头像
					userPhone: "", //手机号
					userCardid: "", //身份证
					roleList: [], //选中的角色id
					roleNames: [], //选中的角色名字
					userState: true, //用户状态 0正常 1禁用
					userStatus: 0,
					deptNo: "",
				},
			});
			//重置数据
			const init = () => {
				data.isAdd = true;
				data.dataItem.userLgname = ''
				data.dataItem.userNickname = ''
				data.dataItem.userHeadImg = ''
				data.dataItem.userPhone = ''
				data.dataItem.userCardid = ''
				data.dataItem.roleList = []
				data.dataItem.roleNames = []
				data.dataItem.userState = true
				data.dataItem.userStatus = 0
				data.dataItem.deptNo = ''

				getTree();
				getRoleList();
			};

			//角色列表
			const getRoleList = async () => {
				const r = await proxy.$http.get("/auth/bdzl/role/userRoleList", {});
				if (r.code === 0 || r.respCode === "0000") {
					data.roleList = r.rows;
				}
			};

			//机构树
			const getTree = async () => {
				const r = await proxy.$http.post(apiObj.orgDeptTree, {});
				console.log(r);
				if (r) {
					let newArr = [];
					newArr.push(r);

					data.treeData = newArr;
					// nextTick(() => {
					//   proxy.$refs.tree.setCurrentKey(r.id);
					// });
				}
			};
			// 显示树形
			const showTree = () => {
				data.isShowTree = !data.isShowTree
			}
			//点击树形
			const handleNodeClick = (node) => {
				console.log(node);
				data.valueTitle = node.text;
				console.log(data.valueTitle);
				data.dataItem.deptNo = node.id;
				data.defaultExpandedKey = [];
			};
			// 上传图片
			const handleAddUploadChange = (file) => {
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isLt2M) {
					imageConversion.compress(file.raw, 0.6).then((res) => {
						imgFileToBase64({
							raw: res
						}, (imageUrl) => {
							data.dataItem.userHeadImg = imageUrl;
							//upLoadBase64uploadToOSS(imageUrl, "orgLogo");
						});
					});
				} else {
					imgFileToBase64(file, (imageUrl) => {
						data.dataItem.userHeadImg = imageUrl;
						//upLoadBase64uploadToOSS(imageUrl, "orgLogo");
					});
				}
			};
			//上传图片
			const upLoadBase64uploadToOSS = async (imageUrl, type) => {
				await proxy.$http.post("/api/ossUpload/base64Json", {
						name: imageUrl,
						value: "TEST/DXD",
					})
					.then((res) => {
						// if(res.)
						//data[type] = res;
						data.dataItem.userHeadImg = res;
					});
			};

			const dialogClosedHandle = () => {
				data.isAdd = false;
			};
			const closeModal = () => {
				data.isAdd = false;
			};
			const submit = async () => {
				if (data.dataItem.userLgname == "") {
					proxy.$message.error("请填写登录账号");
					return;
				}
				if (data.dataItem.userNickname == "") {
					proxy.$message.error("请填写名称");
					return;
				}
				if (data.dataItem.userPhone == "") {
					proxy.$message.error("请填写手机号");
					return;
				}
				// if (data.dataItem.deptNo == "") {
				//   proxy.$message.error("请选择所属部门");
				//   return;
				// }
				if (isPhone(data.dataItem.userPhone) == false) {
					proxy.$message.error("请填写正确的手机号");
					return;
				}
				if (data.dataItem.userCardid == "") {
					proxy.$message.error("请填写身份证号");
					return;
				}
				if (isIdNo(data.dataItem.userCardid) == false) {
				  proxy.$message.error("请填写正确的身份证号");
				  return;
				}
				if (data.dataItem.roleList.length == 0) {
					proxy.$message.error("请选择角色");
					return;
				}
				if (data.dataItem.userState == true) {
					data.dataItem.userStatus = 0;
				}
				if (data.dataItem.userState == false) {
					data.dataItem.userStatus = 1;
				}
				let params = {
					userHeadImg: data.dataItem.userHeadImg,
					userLgname: data.dataItem.userLgname,
					userPwd:"123456",
					userNickname: data.dataItem.userNickname,
					userPhone: data.dataItem.userPhone,
					userCardid: data.dataItem.userCardid,
					roleList: data.dataItem.roleList,
					deptNo: null,
					orgId: null,
				}

				const r = await proxy.$http.post(apiObj.userSave, params)
				if (r.code === 0 || r.respCode === '0000') {
					proxy.$message.success(r.msg || r.respMsg);
					getData();
					data.isAdd = false;
				} else {
					proxy.$message.error(r.msg || r.respMsg);
				}

			};
			const getEditRole = (value) => {
				data.dataItem.roleList = value;
			};
			const closeTree = () => {
				data.isShowTree = false
			}
			return {
				...toRefs(data),
				init,
				closeModal,
				getData,
				getRoleList,
				handleAddUploadChange,
				getTree,
				showTree,
				handleNodeClick,
				dialogClosedHandle,
				submit,
				closeTree
			};
		},
	});
</script>
<style scoped>
	.page_warp {
		width: 100%;
		max-height: 600px;
	}

	.input_row {
		width: 100%;
		padding: 5px 0;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.input_img_row {
		width: 100%;
		height: 80px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.input_lable {
		width: 80px;
		text-align: right;
	}

	.input_box {
		width: 50%;
	}

	.input_tree_warp {
		width: calc(100% - 30px);
		height: 300px;
		margin-left: 30px;

		box-sizing: border-box;
		margin-top: 10px;
		display: flex;
		justify-content: space-between;
	}

	.manage {
		width: 48%;
		height: 100%;

		display: flex;
	}

	.tree {
		width: calc(100% - 80px);
		height: 100%;
		overflow: auto;
	}

	.footer_btn_warp {
		width: 100%;
		height: 70px;
		margin-top: 30px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.cancle_btn {
		width: 116px;
		height: 38px;
		background: #e36a19;
		border-radius: 4px;
		text-align: center;
		color: #fff;
		font-size: 14px;
		line-height: 38px;
		cursor: pointer;
		margin-right: 90px;
	}

	.confirm_btn {
		width: 116px;
		height: 38px;
		background: #293787;
		border-radius: 4px;
		text-align: center;
		color: #fff;
		font-size: 14px;
		line-height: 38px;
		cursor: pointer;
	}

	:deep(.el-select) {
		width: 100%;
	}

	.selectTree {
		position: relative;
		cursor: pointer;
	}

	:deep(.selectTree .el-input__inner) {
		cursor: pointer !important;
	}

	.tree_warp {

		width: 100%;
		height: 200px;
		border: 1px solid #e4e7ed;
		position: absolute;
		left: 0;
		bottom: -205px;
		overflow: auto;
		z-index: 100;
		background: #fff;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
	}

	.tree_warp::-webkit-scrollbar {
		width: 3px;
	}

	.tree_warp::-webkit-scrollbar-thumb {
		background: #e4e7ed;
		border-radius: 20px;
		opacity: 0.3;

	}

	.transform180 {
		transform: rotate(180deg);
	}
</style>